import { getMessages } from '../../../../../../../store/constants';

export const DEPENDENCY_CLASS = 'dependency';
export const REMOVE_DEPENDENCY_TOOLTIP = getMessages().getText('card_form_dependency_remove');
